<template>
    <el-row class="row-bg" >
        <el-col :span="12" style="padding-left:10%;">
            <h2>欢迎来到自动化测试管理平台</h2>
            <br/>
            <el-image :src="require('@/assets/login.png')"></el-image>
        </el-col>
        <el-col :span="1">
            <el-divider direction="vertical"></el-divider>
        </el-col>
        <el-col :span="11">
            <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px">
                <el-form-item label="用户名：" prop="username" style="width: 380px;">
                    <el-input v-model="loginForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password" style="width: 380px;">
                    <el-input v-model="loginForm.password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="验证码：" prop="code" style="width: 380px;">
                    <el-input v-model="loginForm.code" style="width: 172px; float: left" maxlength="5"></el-input>
                    <img :src="captchaImg" class="captchaImg" @click="getCaptcha"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
                    <el-button @click="resetForm('loginForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
</template>

<script>
    import qs from 'qs'
    import ElementUI from 'element-ui'
    const axios = require('axios')
    export default {
        name: 'Login',
        data () {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    code: '',
                    codeid: ''
                },
                rules: {
                    username: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                },
                captchaImg: null
            }
        },
        methods: {
            getCaptcha () {
                this.$axios.get('/captcha/1', {timeout: 6000}).then(res => {
                    this.loginForm.codeid = res.data.data.codeid
                    console.log(res.data.data.codeid)
                    let str = `${res.data.data.captchaImg}`
                    this.captchaImg = str.replace(/[\r\n]/g, '')
                    this.loginForm.code = ''
                })
            },
            submitForm (formName) {
                // console.log('name=' + this.loginForm.username)
                // console.log('password=' + this.loginForm.password)
                // console.log('code=' + this.loginForm.code)
                let that = this
                this.$refs[formName].validate((valid) => {
                    // console.log('valid=' + valid)
                    if (valid) {
                        axios({
                            method: 'post',
                            url: '/user/login',
                            data: qs.stringify(this.loginForm),
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(function (res) {
                            if (res.data.code !== 200) {
                                console.log(res.data.msg)
                                ElementUI.Message.error(res.data.msg)
                                this.getCaptcha()
                            } else {
                                console.log(res.data.data.msg)
                                ElementUI.Message.success(res.data.data.msg)
                                that.$router.push('/index')
                            }
                        })
                    } else {
                        // console.log('登录失败！')
                        ElementUI.Message.error('登录失败！')
                        return false
                    }
                })
            },
            resetForm (formName) {
                Object.assign(this.$data, this.$options.data())
                this.$refs[formName].resetFields()
                this.getCaptcha()
            }
        },
        created () {
            this.getCaptcha()
        }
    }
</script>
<style scoped>
    .row-bg{
        background-color: #fafafa;
        height: 300px;
        position: absolute;
        left:0;
        right:0;
        top:50%;
        transform: translateY(-125px);
        text-align: center;
        padding:100px;
    }
    .el-divider {
        height: 300px;
    }
    .el-form-item {
        margin-top: 30px;
        margin-bottom:0;
    }
    .captchaImg {
        float: left;
        margin-left: 8px;
        border-radius: 4px;
        width:120px;
        height:40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue